/**
 * 用于储字典接口相关的参数和接收接口返回的的vuex的接收存储字段key值
 */
import { mapGetters } from 'vuex'
export const serviceDic = [
  { ditType: 'ROOT_brand', key: 'brand' }, //品牌
  { ditType: 'ROOT_category', key: 'category' }, //品类
  { ditType: 'ROOT_MARKETLEVEL', key: 'MARKETLEVEL' }, //市场级别
  { ditType: 'ROOT_MARKET_FRANCHISE_TYPE', key: 'MARKET_FRANCHISE_TYPE' }, //K3客户渠道
  { ditType: 'ROOT_K3_CUSTOMER_CHANNEL', key: 'K3_CUSTOMER_CHANNEL' }, //商场加盟类型
  { ditType: 'ROOT_MARKET_CHANGE_TYPE', key: 'MARKET_CHANGE_TYPE' }, //商场变更类型
  { ditType: 'ROOT_MARKET_CHANNEL_TYPE', key: 'MARKET_CHANNEL_TYPE' }, //商场渠道类型
  { ditType: 'ROOT_AGENT_NATURE', key: 'AGENT_NATURE' }, //经销商性质
  { ditType: 'ROOT_FINANCIAL_CHANNEL_TYPE', key: 'FINANCIAL_CHANNEL_TYPE' }, //财务渠道
  { ditType: 'ROOT_product_category', key: 'product_category' }, //产品类别：
  { ditType: 'ROOT_MARKET_CUSTOMER_TYPE', key: 'MARKET_CUSTOMER_TYPE' }, //商场客户类型
  { ditType: 'ROOT_MTDS_customer_status', key: 'customer_status' }, //转移客户状态
  { ditType: 'ROOT_MARKET_ROLE_SHARE_TYPE', key: 'MARKET_ROLE_SHARE_TYPE' }, //商场角色共享方式
  { ditType: 'ROOT_ORG_TYPE', key: 'ORG_TYPE' }, //组织分类
  { ditType: 'ROOT_market_classify', key: 'market_classify' }, //营销线标识
  { ditType: 'ROOT_PROCESS_TYPE', key: 'PROCESS_TYPE' }, //流程表单类型
  { ditType: 'ROOT_PLATFORM', key: 'PLATFORM' }, //平台
  { ditType: 'ROOT_RelationBusinessType', key: 'RelationBusinessType' }, //商场跨区关联业务类型
  { ditType: 'ROOT_AGENT_TYPE', key: 'AGENT_TYPE' }, //商场经销商类型
  { ditType: 'ROOT_Rectification', key: 'Rectification' }, //整改类型
  { ditType: 'ROOT_MARKET_ROCK_SERVICE_MODE_TYPE', key: 'MARKET_ROCK_SERVICE_MODE_TYPE' }, //岩板台面服务模式
  { ditType: 'ROOT_LOCATION_TYPE', key: 'LOCATION_TYPE' }, //店面位置类型
  { ditType: 'ROOT_STORE_TYPE', key: 'STORE_TYPE' }, //店面类型
  { ditType: 'ROOT_MARKET_POST_TYPE', key: 'MARKET_POST_TYPE' }, //商场岗位类型
  { ditType: 'ROOT_SHOP_TYPE', key: 'SHOP_TYPE' }, //店面性质
  { ditType: 'ROOT_PromotionType', key: 'PromotionType' }, //促销类型
  { ditType: 'ROOT_MARKET_DESIGN_SOURCE_TYPE', key: 'MARKET_DESIGN_SOURCE_TYPE' }, //设计来源
  { ditType: 'ROOT_ProductChannel', key: 'ProductChannel' }, //产品渠道
  { ditType: 'ROOT_SHOP_MANAGEMENT_MODEL_TYPE', key: 'SHOP_MANAGEMENT_MODEL_TYPE' }, //经营模式
  { ditType: 'ROOT_LINE_TYPE', key: 'LINE_TYPE' }, //层级
  { ditType: 'ROOT_ACCOUNT_LABEL_TYPE', key: 'ACCOUNT_LABEL_TYPE' }, //账号标签类型
  { ditType: 'ROOT_PHYSICAL_SHOP_TYPE', key: 'PHYSICAL_SHOP_TYPE' }, //店面类型
  { ditType: 'ROOT_COOPERATION_TYPE', key: 'COOPERATION_TYPE' }, //合作类型
  { ditType: 'ROOT_SHOP_ATTRIBUTE', key: 'SHOP_ATTRIBUTE' }, //店面属性
  { ditType: 'ROOT_SHOP_LOCATION', key: 'SHOP_LOCATION' }, //店面位置
  { ditType: 'ROOT_SHOP_AGENT_TYPE', key: 'SHOP_AGENT_TYPE' }, //代理商类型
  { ditType: 'ROOT_CUSTOMER_NATURE', key: 'CUSTOMER_NATURE' }, //客户性质
  { ditType: 'ROOT_SYSTEM_IDENTITY', key: 'SYSTEM_IDENTITY' }, //体系内外标识
  { ditType: 'ROOT_ELECTRICAL_PRODUCT_TYPE', key: 'ELECTRICAL_PRODUCT_TYPE' }, //电器百货产品类别
  { ditType: 'ROOT_DECORATE_TYPE', key: 'DECORATE_TYPE' }, //整改类型
  { ditType: 'ROOT_FORM_TYPE', key: 'FORM_TYPE' }, //表单类型
  { ditType: 'ROOT_K3_CUSTOMER_CHANNEL', key: 'K3_CUSTOMER_CHANNEL' }, //表单类型
  { ditType: 'ROOT_PHYSICAL_SHOP_IDENTITY', key: 'PHYSICAL_SHOP_IDENTITY' }, //实体店标识
  // {ditType: 'ROOT_IS_VALID ', key: 'IS_VALID'},//是否有效商场
  // {ditType: 'ROOT_MESSAGE', key: 'MESSAGE'},//消息类型
  // {ditType: 'ROOT_SEX', key: 'SEX'},//性别
  // {ditType: 'ROOT_ProfessionType', key: 'ProfessionType'},//专业类型
  // {ditType: 'ROOT_information_type', key: 'information_type'},//商场数据类型
]
export const seviceMinxins = {
  methods: {
    checkServiceDictionary(keyword) {
      let storeDic = this.$store.state.common.serviceDic
      if (keyword && !(Array.isArray(storeDic[keyword]) && storeDic[keyword].length > 0)) {
        let keywordInDic = serviceDic.find((i) => i.key === keyword)
        if (keywordInDic) {
          this.$store.dispatch('setCommonServiceDic', { ditTypes: keywordInDic.ditType })
        }
      } else {
        let dicTypeList = []
        serviceDic.forEach((i) => {
          if (
            !(Array.isArray(storeDic[i.key]) && storeDic[i.key].length > 0) &&
            !dicTypeList.includes(i.ditType)
          ) {
            dicTypeList.push(i.ditType)
          }
        })
        if (dicTypeList.length > 0) {
          this.$store.dispatch('setCommonServiceDic', { ditTypes: dicTypeList.join(',') })
        }
      }
    },
    getTargetListInServiceDic(keyword, callback) {
      //这里相当于检测并赋值vuex里面的目标值
      if (typeof callback === 'function') {
        callback()
      } else {
        this.checkServiceDictionary(keyword)
      }
      return this.commonServiceDictList(keyword)
    },
    deverseAdmission(sign, parentId) {
      if (parentId && sign) {
        return this.access.find((i) => i.permission === sign && i.parentId === parentId)
      }
      return false
    },
    operateable(keyword) {
      let result = false
      let permission = this.permissions ? this.permissions.split('|') : []
      if (typeof keyword === 'string') {
        if (keyword) {
          result = permission.includes(keyword)
        }
      } else if (Array.isArray(keyword)) {
        keyword.forEach((i) => {
          if (i) {
            result = permission.includes(i)
          }
        })
      }
      return result
    },
  },
  mounted() {},
  computed: {
    access() {
      //用户拥有的权限
      return this.$store.state.auth.access
    },
    permissions() {
      //用户拥有的权限
      return this.$store.state.auth.permission
    },
    ...mapGetters(['commonServiceDictList']),
  },
}
